import RootDev from './Root.dev';
import RootProd from './Root.prod';

const root = process.env.NODE_ENV === 'production' ? RootProd : RootDev;

export default root;
